function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { wordDiff, nameOf, initialsOf } from "./collab";

/*
 * Content Hub review and sign-off, phase 4 (PlunkDocs specs/CONTENT_HUB_REVIEW_DESK_2026-10-21.md §4.3, mockups A and C).
 * ReviewBox: one piece's round: who reviews (required / optional), what each said, and for me as a reviewer Sign off or
 * Request changes; after an edit, "changed since you signed off" with the words that changed. RequestReviewSheet: pick
 * pieces, reviewers, due date, a message and (moderators) approve when everyone signs off. Reads and writes through the
 * Builder (b.reviewOf, b.castVote, b.requestReview, b.cancelReview).
 */
const plain = h => String(h || "").replace(/<(br|\/p|\/div|\/li|\/h\d)[^>]*>/gi, "\n").replace(/<[^>]+>/g, " ").replace(/&nbsp;/g, " ").replace(/&amp;/g, "&").replace(/[ \t]+/g, " ").replace(/\n\s*\n+/g, "\n\n").trim();
const nameFor = (b, email) => {
  const u = b.teamUsers().find(x => x.email === String(email || "").toLowerCase());
  return u && u.name || nameOf(email);
};
const VOTE = {
  signed_off: ["Signed off", "ok", "check_circle"],
  changes_requested: ["Asked for changes", "bad", "edit_note"],
  pending: ["Waiting", "idle", "schedule"]
};
export const REVIEW_CHIP = {
  in_review: ["In review", "info"],
  changes: ["Changes asked", "warn"],
  signed: ["Signed off", "ok"]
};
export class ReviewBox extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      asking: false,
      note: "",
      busy: false,
      showDiff: false,
      signedText: undefined
    });
    /** The text I signed: the earlier version whose hash matches my vote (for "what changed"). */
    _defineProperty(this, "findSigned", async () => {
      const m = this.mine();
      if (!m || !m.changedSince || !m.versionHash) {
        if (this.state.signedText !== undefined) this.setState({
          signedText: undefined
        });
        return;
      }
      const hs = this.props.b.historyFor(this.props.v);
      for (const h of hs.slice().reverse()) {
        if ((await this.props.b.hashOf(h.title, h.body)) === m.versionHash) {
          this.setState({
            signedText: h
          });
          return;
        }
      }
      this.setState({
        signedText: null
      });
    });
    _defineProperty(this, "vote", async choice => {
      const {
        b,
        v
      } = this.props;
      const rv = b.reviewOf(v);
      if (!rv) return;
      this.setState({
        busy: true
      });
      const ok = await b.castVote(rv.review.id, v, choice, choice === "changes_requested" ? this.state.note.trim() : "");
      this.setState({
        busy: false,
        ...(ok ? {
          asking: false,
          note: "",
          showDiff: false
        } : {})
      });
    });
  }
  componentDidMount() {
    this.findSigned();
  }
  componentDidUpdate(prev) {
    if (prev.v !== this.props.v) this.findSigned();
  }
  mine() {
    const rv = this.props.b.reviewOf(this.props.v);
    const me = this.props.b.me();
    return rv ? rv.votes.find(x => String(x.reviewer).toLowerCase() === me) : null;
  }
  render() {
    const {
      b,
      v
    } = this.props;
    const rv = b.reviewOf(v);
    if (!rv) return null;
    const {
      review,
      votes
    } = rv;
    const me = b.me();
    const mine = this.mine();
    const st = b.reviewState(v);
    const chip = st ? REVIEW_CHIP[st] : null;
    const open = review.status !== "cancelled";
    const canCancel = review.status === "open" && (String(review.createdBy).toLowerCase() === me || b.isModerator());
    const sig = this.state.signedText;
    return /*#__PURE__*/React.createElement("div", {
      className: "bm-sec bm-review"
    }, /*#__PURE__*/React.createElement("div", {
      className: "bm-review-hd"
    }, /*#__PURE__*/React.createElement("span", {
      className: "bm-h"
    }, "Review"), chip && /*#__PURE__*/React.createElement("span", {
      className: "bm-chip " + chip[1]
    }, chip[0])), /*#__PURE__*/React.createElement("span", {
      className: "bm-sub left"
    }, "Asked by ", nameFor(b, review.createdBy), review.due ? ` · due ${new Date(review.due + "T12:00").toLocaleDateString([], {
      month: "short",
      day: "numeric"
    })}` : "", review.approveOnSignoff ? " · approves when everyone signs off" : ""), review.message && /*#__PURE__*/React.createElement("div", {
      className: "bm-review-msg"
    }, review.message), /*#__PURE__*/React.createElement("div", {
      className: "bm-votes"
    }, votes.map(x => {
      const [lbl, tone, icon] = VOTE[x.vote] || VOTE.pending;
      return /*#__PURE__*/React.createElement("div", {
        key: x.id,
        className: "bm-vote"
      }, /*#__PURE__*/React.createElement("span", {
        className: "bm-av"
      }, initialsOf(x.reviewer)), /*#__PURE__*/React.createElement("span", {
        className: "bm-vote-who"
      }, /*#__PURE__*/React.createElement("b", null, nameFor(b, x.reviewer), String(x.reviewer).toLowerCase() === me ? " (you)" : ""), /*#__PURE__*/React.createElement("i", null, x.required ? "Required" : "Optional")), /*#__PURE__*/React.createElement("span", {
        className: "bm-vote-st " + tone
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons"
      }, icon), x.changedSince && x.vote === "pending" ? String(x.reviewer).toLowerCase() === me ? "Changed since your last look" : "Changed since their last look" : lbl), x.note && x.vote === "changes_requested" && /*#__PURE__*/React.createElement("div", {
        className: "bm-vote-note"
      }, x.note));
    })), open && mine && mine.vote === "pending" && /*#__PURE__*/React.createElement("div", {
      className: "bm-vote-acts"
    }, mine.changedSince && /*#__PURE__*/React.createElement("div", {
      className: "bm-changed"
    }, /*#__PURE__*/React.createElement("span", null, "This piece changed since your last look."), sig && /*#__PURE__*/React.createElement("button", {
      className: "bm-link",
      "aria-expanded": this.state.showDiff,
      onClick: () => this.setState({
        showDiff: !this.state.showDiff
      })
    }, this.state.showDiff ? "Hide what changed" : "What changed"), sig && this.state.showDiff && /*#__PURE__*/React.createElement("div", {
      className: "bm-diff",
      "aria-label": "Changes since your last look"
    }, wordDiff(plain(sig.body), plain(v.body)).map((d, k) => d.op === "same" ? /*#__PURE__*/React.createElement("span", {
      key: k
    }, d.t) : d.op === "add" ? /*#__PURE__*/React.createElement("ins", {
      key: k
    }, d.t) : /*#__PURE__*/React.createElement("del", {
      key: k
    }, d.t)))), this.state.asking ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("textarea", {
      rows: 3,
      value: this.state.note,
      placeholder: "What should change?",
      autoFocus: true,
      onChange: e => this.setState({
        note: e.target.value
      })
    }), /*#__PURE__*/React.createElement("div", {
      className: "bm-row-acts"
    }, /*#__PURE__*/React.createElement("button", {
      className: "bm-btn sm",
      disabled: this.state.busy || !this.state.note.trim(),
      onClick: () => this.vote("changes_requested")
    }, this.state.busy ? "Sending…" : "Send"), /*#__PURE__*/React.createElement("button", {
      className: "bm-link mute",
      onClick: () => this.setState({
        asking: false
      })
    }, "Cancel"))) : /*#__PURE__*/React.createElement("div", {
      className: "bm-row-acts"
    }, /*#__PURE__*/React.createElement("button", {
      className: "bm-btn sm primary",
      disabled: this.state.busy,
      onClick: () => this.vote("signed_off")
    }, "Sign off"), /*#__PURE__*/React.createElement("button", {
      className: "bm-btn sm",
      disabled: this.state.busy,
      onClick: () => this.setState({
        asking: true
      })
    }, "Request changes"))), canCancel && /*#__PURE__*/React.createElement("button", {
      className: "bm-link mute left",
      onClick: () => b.cancelReview(review.id)
    }, "Cancel this review"));
  }
}

/** Request review (mockup C). pieces: [{ v, title, kind }] written pieces of this story. */
export class RequestReviewSheet extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "send", async () => {
      const reviewers = Object.entries(this.state.who).filter(([, r]) => r).map(([email, r]) => ({
        email,
        required: r === "required"
      }));
      const variantIds = Object.keys(this.state.picks).filter(k => this.state.picks[k]);
      this.setState({
        busy: true
      });
      const ok = await this.props.b.requestReview({
        variantIds,
        reviewers,
        due: this.state.due || null,
        message: this.state.message.trim() || null,
        approveOnSignoff: this.state.auto
      });
      this.setState({
        busy: false
      });
      if (ok) this.props.onClose();
    });
    const b = props.b;
    const pre = props.preselect ? String(props.preselect) : null;
    const picks = {};
    props.pieces.forEach(p => {
      const st = String(p.v.status || "").toLowerCase();
      picks[String(p.v.id)] = pre ? String(p.v.id) === pre : !["approved", "published", "live"].includes(st) && !b.reviewState(p.v);
    });
    this.state = {
      picks,
      who: {},
      due: "",
      message: "",
      auto: false,
      busy: false
    };
  }
  render() {
    const {
      b,
      pieces,
      onClose
    } = this.props;
    const me = b.me();
    const people = b.teamUsers().filter(u => u.email !== me);
    const nPieces = Object.values(this.state.picks).filter(Boolean).length;
    const who = Object.values(this.state.who).filter(Boolean);
    const hasRequired = who.includes("required");
    return /*#__PURE__*/React.createElement("div", {
      className: "wa-modal-backdrop hub-edit-backdrop",
      onClick: onClose
    }, /*#__PURE__*/React.createElement("div", {
      className: "hub-trash-sheet bm-rr",
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": "bm-rr-h",
      onClick: e => e.stopPropagation()
    }, /*#__PURE__*/React.createElement("h3", {
      id: "bm-rr-h",
      className: "hub-h3",
      style: {
        margin: 0
      }
    }, "Request review"), /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: "4px 0 12px"
      }
    }, "Reviewers sign off or ask for changes on each piece. ", b.isModerator() ? "You approve once everyone has signed off, or let it approve itself." : b.state.team && b.state.team.moderatorApproval ? "A moderator approves once everyone has signed off." : "Pieces can be approved once everyone has signed off."), /*#__PURE__*/React.createElement("div", {
      className: "bm-rr-cols"
    }, /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement("legend", null, "Pieces"), pieces.map(p => {
      const id = String(p.v.id);
      const st = b.reviewState(p.v);
      const done = ["approved", "published", "live"].includes(String(p.v.status || "").toLowerCase());
      return /*#__PURE__*/React.createElement("label", {
        key: id,
        className: "bm-rr-row"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        checked: !!this.state.picks[id],
        disabled: done && String(p.v.status).toLowerCase() !== "approved",
        onChange: e => this.setState({
          picks: {
            ...this.state.picks,
            [id]: e.target.checked
          }
        })
      }), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, p.title), /*#__PURE__*/React.createElement("i", null, p.kind, done ? " · approved" : st ? ` · ${REVIEW_CHIP[st][0].toLowerCase()}` : "")));
    })), /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement("legend", null, "Reviewers"), people.length === 0 && /*#__PURE__*/React.createElement("p", {
      className: "bm-sub left"
    }, "Nobody else is in this workspace yet."), people.map(u => /*#__PURE__*/React.createElement("div", {
      key: u.email,
      className: "bm-rr-row"
    }, /*#__PURE__*/React.createElement("span", {
      className: "bm-av"
    }, initialsOf(u.email)), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, u.name), /*#__PURE__*/React.createElement("i", null, u.email)), /*#__PURE__*/React.createElement("select", {
      "aria-label": `${u.name}'s part`,
      value: this.state.who[u.email] || "",
      onChange: e => this.setState({
        who: {
          ...this.state.who,
          [u.email]: e.target.value
        }
      })
    }, /*#__PURE__*/React.createElement("option", {
      value: ""
    }, "Not reviewing"), /*#__PURE__*/React.createElement("option", {
      value: "required"
    }, "Required"), /*#__PURE__*/React.createElement("option", {
      value: "optional"
    }, "Optional")))))), /*#__PURE__*/React.createElement("div", {
      className: "bm-rr-foot"
    }, /*#__PURE__*/React.createElement("label", {
      className: "bm-field"
    }, /*#__PURE__*/React.createElement("span", null, "Due"), /*#__PURE__*/React.createElement("input", {
      type: "date",
      value: this.state.due,
      onChange: e => this.setState({
        due: e.target.value
      })
    })), /*#__PURE__*/React.createElement("textarea", {
      rows: 2,
      value: this.state.message,
      placeholder: "A note for the reviewers (optional)",
      onChange: e => this.setState({
        message: e.target.value
      })
    }), b.isModerator() && /*#__PURE__*/React.createElement("label", {
      className: "bm-rr-auto"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: this.state.auto,
      onChange: e => this.setState({
        auto: e.target.checked
      })
    }), "Approve each piece when everyone required signs off")), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        justifyContent: "flex-end",
        gap: 8,
        marginTop: 14
      }
    }, /*#__PURE__*/React.createElement("button", {
      className: "territory-toggle",
      style: {
        margin: 0
      },
      onClick: onClose
    }, "Cancel"), /*#__PURE__*/React.createElement("button", {
      className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary",
      disabled: this.state.busy || !nPieces || !hasRequired,
      onClick: this.send
    }, this.state.busy ? "Sending…" : `Ask ${who.length || ""} to review ${nPieces} piece${nPieces === 1 ? "" : "s"}`))));
  }
}